import React from 'react';
import { Edit2, Trash2, Layers, Grid } from 'lucide-react';

interface Zone {
    id: string;
    zoneName: string;
    floorLevel: number;
    area: number;
    requiredUnits: number;
    createdAt: number;
}

interface ZoneCardProps {
    zone: Zone;
    onEdit: (zone: Zone) => void;
    onDelete: (zoneId: string) => void;
}

export default function ZoneCard({ zone, onEdit, onDelete }: ZoneCardProps) {
    return (
        <div className="card-glass p-6 hover:shadow-lg transition-all duration-300 group">
            <div className="flex justify-between items-start mb-4">
                <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-ember-500/10 rounded-lg flex items-center justify-center text-ember-500 group-hover:bg-ember-500 group-hover:text-white transition-colors">
                        <Layers className="w-5 h-5" />
                    </div>
                    <div>
                        <h4 className="font-display font-bold text-white text-lg">
                            {zone.zoneName}
                        </h4>
                        <p className="text-steel-400 text-sm">
                            Floor Level: {zone.floorLevel}
                        </p>
                    </div>
                </div>
                <div className="flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                    <button
                        onClick={() => onEdit(zone)}
                        className="p-2 hover:bg-steel-700/50 rounded-lg text-steel-400 hover:text-white transition-colors"
                        title="Edit Zone"
                    >
                        <Edit2 className="w-4 h-4" />
                    </button>
                    <button
                        onClick={() => onDelete(zone.id)}
                        className="p-2 hover:bg-red-500/20 rounded-lg text-steel-400 hover:text-red-400 transition-colors"
                        title="Delete Zone"
                    >
                        <Trash2 className="w-4 h-4" />
                    </button>
                </div>
            </div>

            <div className="grid grid-cols-2 gap-4 pt-4 border-t border-steel-700/30">
                <div>
                    <p className="text-xs text-steel-500 mb-1 flex items-center gap-1">
                        <Grid className="w-3 h-3" /> Area
                    </p>
                    <p className="font-semibold text-white">
                        {zone.area} m²
                    </p>
                </div>
                <div>
                    <p className="text-xs text-steel-500 mb-1">Required Units</p>
                    <div className="flex items-center gap-2">
                        <span className="font-semibold text-white text-lg">
                            {zone.requiredUnits}
                        </span>
                        <span className="text-xs px-2 py-0.5 rounded-full bg-safety-500/20 text-safety-400 border border-safety-500/30">
                            Required
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}
